import React from 'react'
import ChatLayout from '../Components/Chat/ChatLayout'

const ChatPage = () => {
  return (
      <div>
        <ChatLayout />  
      </div>
  )
}

export default ChatPage